import 'babel-polyfill'
import LogRocket from 'logrocket'
import React from 'react'
import ReactDOM from 'react-dom'
import { Provider } from 'react-redux'
import configureStore from './redux/store'
import { setTimeZoneOffset } from './utils/dateUtils'
import { enableES5 } from 'immer'

enableES5()

const logRocketConfig = extConfig.LOG_ROCKET_CONFIG
if (logRocketConfig) {
  LogRocket.init(logRocketConfig)
}

const rootEl = document.getElementById('body')

const serverData = window.__SERVER_DATA__
delete window.__SERVER_DATA__

setTimeZoneOffset(serverData.timeZone.offset)

const store = configureStore(serverData)

let render = () => {
  const App = require('./App').default
  //const history = syncHistoryWithStore(browserHistory, store)
  ReactDOM.render(
    <Provider store={store}>
      <App />
    </Provider>,
    rootEl
  )
}

if (module.hot) {
  const renderApp = render
  const renderError = error => {
    const RedBox = require('redbox-react').default
    ReactDOM.render(<RedBox error={error} />, rootEl)
  }
  render = () => {
    try {
      renderApp()
    } catch (error) {
      renderError(error)
    }
  }
  module.hot.accept('./App', () => {
    setTimeout(render)
  })
}

render()



// WEBPACK FOOTER //
// ./src/index.js